var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-wrap" },
    [
      _c("ActionsBar", {
        attrs: {
          pageTitle: "products",
          addNew: function() {
            this$1.openModal()
          }
        }
      }),
      _vm._v(" "),
      !_vm.loader
        ? _c("v-card", { attrs: { "pa-4": "" } }, [
            _c(
              "div",
              { staticClass: "data-wrap mt-4" },
              [
                _c(
                  "v-expansion-panels",
                  { staticClass: "orders" },
                  _vm._l(_vm.list, function(item, key) {
                    return _c(
                      "v-expansion-panel",
                      { key: key },
                      [
                        _c(
                          "v-expansion-panel-header",
                          {
                            attrs: { "disable-icon-rotate": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.openItemEdit(item)
                                            }
                                          }
                                        },
                                        [_vm._v("mdi-pencil")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-icon", { staticClass: "ml-4" }, [
                                        _vm._v("$expand")
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("div", { staticClass: "item-header" }, [
                              _c("div", { staticClass: "item-title" }, [
                                _vm._v(_vm._s(item.title))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item-subtitle" }, [
                                _vm._v(_vm._s(item.slug))
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("v-expansion-panel-content", [
                          item.description
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(item.description) + "\n\t\t\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "storage-units" },
                            _vm._l(item.storageUnits, function(unit, key) {
                              return _c(
                                "v-card",
                                { key: key, staticClass: "unit" },
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src: unit.preview,
                                      height: "200px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-title",
                                    [
                                      _c("span", [_vm._v(_vm._s(unit.title))]),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.openUnitEdit(
                                                unit,
                                                item.uid
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("mdi-pencil")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-card-subtitle", [
                                    unit.price
                                      ? _c("span", [
                                          _vm._v("Price: " + _vm._s(unit.price))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    unit.quantity
                                      ? _c("span", [
                                          _vm._v(
                                            "Quantity: " + _vm._s(unit.quantity)
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "unit-details" }, [
                                    _c("p", [
                                      _c("span", [_vm._v("SKU Number: ")]),
                                      _vm._v(" " + _vm._s(unit.sku_number))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      unit.characteristics &&
                                      unit.characteristics.volume
                                        ? _c(
                                            "p",
                                            { staticClass: "unit-title" },
                                            [
                                              _c("span", [_vm._v("Volume: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    unit.characteristics.volume
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "load-more" },
                  [
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.loadMore()
                          }
                        }
                      },
                      [
                        _c("v-icon", [_vm._v("mdi-reload")]),
                        _vm._v(" Load more")
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _c(
            "div",
            { staticClass: "loader" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" }
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.modal1
        ? _c("ItemForm", {
            attrs: {
              item: _vm.selectedItem,
              modal: _vm.modal1,
              formTitle: "Update Item",
              action: _vm.action,
              close: function() {
                _vm.closeModal()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modal2
        ? _c("ItemForm", {
            attrs: {
              unit: _vm.selectedItem,
              uid: _vm.selectedUID,
              modal: _vm.modal2,
              formTitle: "Update Storage Unit",
              action: _vm.action,
              close: function() {
                _vm.closeModal()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("DeleteDialog", {
        attrs: {
          modal: _vm.deleteModal,
          item: _vm.selectedItem,
          action: _vm.action,
          close: function() {
            _vm.closeDelete()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }